import gql from 'graphql-tag';

const LOG_BACKEND = gql`
  mutation LogBackend($input: [LogBackendInput!]!) {
    logBackend(input: $input)
  }
`;

export { LOG_BACKEND };
